import { INTENT_TYPE } from '../../constants';
import { resolveCueFamily } from '../features/cue-family';
import { RETRIEVE_CUES, RETRIEVE_EXCLUSIONS } from '../pack/lexicons';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `C-RETRIEVE` (priority 950) — "get me this" phrased as a request.
 *
 * `give me launch docs` is the reported gap this family closes: its sibling phrases
 * (`show me`, `tell me`) were already covered, so the omission produced an inconsistency
 * users could feel.
 *
 * `find out why|what|how` is excluded explicitly. It is an indirect question rather than a
 * retrieval request, and the residual layer is better placed to judge it than a cue match.
 *
 * This family carries the highest title-collision risk of the three cue families, because
 * `list` and `show` open a lot of real page names.
 */
export const matchesRetrieve = (features: FeatureContext): boolean =>
	resolveCueFamily(features, { cues: RETRIEVE_CUES, exclusions: RETRIEVE_EXCLUSIONS }) !== null;

export const retrieveRule: ConvergenceRule = {
	type: INTENT_TYPE.CHAT,
	pattern: 'RETRIEVE_REQUEST',
	matches: matchesRetrieve,
};
